import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupHeaderComponent } from '../../common/popup-header/popup-header.component';

@Component({
    selector: 'app-enabler-item-choice',
    templateUrl: './enabler-item-choice.component.html',
    styleUrls: ['./enabler-item-choice.component.scss'],
    imports: [PopupHeaderComponent]
})
export class EnablerItemChoiceComponent {
  constructor(
    public dialogRef: MatDialogRef<EnablerItemChoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  selectType(choice: 'project' | 'product') {
    this.dialogRef.close(choice);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
